import { render, staticRenderFns } from "./ConsumptionsSidebar.vue?vue&type=template&id=63366b9c&"
import script from "./ConsumptionsSidebar.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ConsumptionsSidebar.vue?vue&type=style&index=0&id=63366b9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports